import type { PricingVersionTuple } from '../../model/model.ts'

import type { EsMrpwPricingVersionFormat } from './model.ts'

export const esMrpwPricingVersionsDefinitions = [
  ['pricing-es-mrp-wakam-1.0.0-2026-01-13', { label: '1.0.0 - Initial version' }],
  ['pricing-es-mrp-wakam-1.1.0-2026-11-06', { label: '1.1.0 - Raise default management fees to 15%' }],
] as const satisfies PricingVersionTuple<EsMrpwPricingVersionFormat>[]

export type EsMrpwPricingVersion = (typeof esMrpwPricingVersionsDefinitions)[number][0]

export const esMrpwPricingVersions = esMrpwPricingVersionsDefinitions.map<EsMrpwPricingVersion>(([version]) => version)
